export const BUYER_AGENT_MATCH_SEGMENT = "buyer_agent_match";
export const EXPERTS_LAUNCH_SEGMENT = "experts_launch";
export const LIKE_LISTINGS_SEGMENT = "like_listings";
export const LISTING_AGENT_MATCH_SEGMENT = "listing_agent_match";
export const LUXURY_SEGMENT = "luxury";
export const TOWNHOUSE_SEGMENT = "townhouse";
export const VERTICAL_LIVING_SEGMENT = "vertical_living";

export const ADMIN_MANAGEABLE_SEGMENT_NAMES = [
  EXPERTS_LAUNCH_SEGMENT,
  LISTING_AGENT_MATCH_SEGMENT,
  LUXURY_SEGMENT
];

export const EXPERT_OPTABLE_SEGMENT_NAMES = [
  BUYER_AGENT_MATCH_SEGMENT,
  EXPERTS_LAUNCH_SEGMENT,
  LIKE_LISTINGS_SEGMENT,
  TOWNHOUSE_SEGMENT
];
